import http from '../common/http';
import ProfessionalResponse from '../common/interfaces/Professionals/ProfessionalResponse';
import ProfessionalPatchType from '../common/interfaces/Professionals/ProfessionalPatchType';

class DashboardService {
  getSectors() {
    return http.get('/sectors');
  }

  getFilters() {
    return http.get('/professionals/filters');
  }

  checkSubdomain(subdomain: string) {
    return http.get(`/subdomains/${subdomain}`);
  }

  getProfessional(id: string): Promise<ProfessionalResponse> {
    return http.get(`/professionals/${id}`).then(response => response.data);
  }

  updateProfessional(id: string, data: ProfessionalPatchType): Promise<ProfessionalResponse> {
    return http.patch(`/professionals/${id}`, data).then(response => response.data);
  }

  changeSubdomain(id: string, data: { subdomain: string }) {
    return http.post(`/professionals/change-subdomain/${id}`, data);
  }
}

export default new DashboardService();
